import React from "react";
import { Pie } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";

ChartJS.register(ArcElement, Tooltip, Legend);

const PieChart = ({ data, colors = null }) => {
  const defaultColors = [
    "#1976d2",
    "#dc004e",
    "#9c27b0",
    "#f50057",
    "#3f51b5",
    "#00bcd4",
    "#4caf50",
    "#ff9800",
    "#795548",
    "#607d8b",
  ];

  const chartData = {
    labels: data.map((item) => item.value),
    datasets: [
      {
        data: data.map((item) => item.count),
        backgroundColor: colors || defaultColors.slice(0, data.length),
        borderWidth: 1,
        borderColor: "#fff",
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "right",
        labels: {
          generateLabels: (chart) => {
            const dataset = chart.data.datasets[0];
            return chart.data.labels.map((label, i) => {
              const item = data[i];
              return {
                text: `${label} (${item.percentage}%)`,
                fillStyle: dataset.backgroundColor[i],
                hidden: false,
                index: i,
              };
            });
          },
        },
      },
      tooltip: {
        callbacks: {
          label: (context) => {
            const item = data[context.dataIndex];
            return `${item.count} responses (${item.percentage}%)`;
          },
        },
      },
    },
  };

  return (
    <div style={{ height: "300px" }}>
      <Pie
        data={chartData}
        options={options}
      />
    </div>
  );
};

export default PieChart;
